import { Storage } from '@lightningjs/sdk';

export const checkImage = (alternativeCovers, originalImage) => {
  if (alternativeCovers && alternativeCovers['series']) {
    // console.log('Series exists:', alternativeCovers['series']);
    const alternativeCoverss = alternativeCovers['series'];
    if (Object.keys(alternativeCoverss).length > 0) {
      let coverUrl = Object.values(alternativeCoverss)[0];
      // console.log('fired', coverUrl);
      return coverUrl;
    } else {
      return originalImage;
    }
  } else {
    return originalImage;
  }
};

export const findCorrectStream = (movieInfo) => {
  let movieId = movieInfo.id;
  let contentPreferences = Storage.get('content_preferences');
  let profileId = Storage.get('profileId');
  let defaultValue = Storage.get(`audiosubtitles-${profileId}`);
  let movieConfiguration = contentPreferences?.find(
    (preference) => preference.profileId === profileId && preference.movieId === movieId
  );
  let subtitle = 'none';
  let credits_start_at = movieInfo.languages[defaultValue.audio]?.credits_start_at;
  let audio = movieInfo.languages[defaultValue.audio]?.hls_stream_url;
  if (defaultValue) {
    if (movieInfo.languages[defaultValue.audio]?.hls_stream_url) {
      audio = movieInfo.languages[defaultValue.audio].hls_stream_url;
      credits_start_at = movieInfo.languages[defaultValue.audio]?.credits_start_at;
    }
    if (movieInfo.languages[defaultValue.subtitle]?.subtitles_file) {
      subtitle = movieInfo.languages[defaultValue.subtitle].subtitles_file;
    }
    if (movieConfiguration) {
      subtitle = 'none';
      audio = movieInfo.languages[defaultValue.audio]?.hls_stream_url;
      credits_start_at = movieInfo.languages[defaultValue.audio].credits_start_at;
      if (movieInfo.languages[movieConfiguration.subtitle]?.subtitles_file) {
        subtitle = movieInfo.languages[movieConfiguration.subtitle].subtitles_file;
      }
      audio = movieInfo.languages[movieConfiguration.audio]?.hls_stream_url;
      credits_start_at = movieInfo.languages[movieConfiguration.audio].credits_start_at;
    }
  }
  return { subtitle: subtitle, videoStream: audio, credits_start_at: credits_start_at };
};
